export default {
    "start_action-desktop": "Press D to start",
    "start_action-mobile": "Tap to start",
    "backflip": "Backflip!",
    "double_backflip": "Double Backflip!",
    "tripple_backflip": "Triple Backflip!",
    "quadruple_backflip":"Quadruple Backflip!",
    "frontflip": "Frontflip!",
    "double_frontflip":"Double Frontflip!!",
    "tripple_frontflip":"Triple Frontflip!",
    "quadruple_frontflip":"Quadruple Frontflip!",
    "wheelie": "Wheelie!",
    "endo": "Endo!",
    "big_air": "Big Air!",
    "perfect_landing": "Perfect Landing!",
    "end_action-desktop": "Press D to restart",
    "end_action-mobile": "Tap to try again",
    "leaderboards-title": "Leaderboards",
    "leaderboard-title-global": "Global",
    "leaderboard-title-globalfriends": "Friends",
    "leaderboard-title-weekly": "Weekly",
    "leaderboard-title-contextual": "Challengers",
    "rank_1": "1st",
    "rank_2": "2nd",
    "rank_3": "3rd",
    "rank_4": "4th",
    "rank_5": "5th"
}